"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class FormsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async submitSchoolLeadsForm(data) {
        const url = `${this.url}/api/forms/school-leads`;
        const options = { method: 'POST', body: JSON.stringify(data) };
        const expectedResponses = [201, 422];
        return await this.requestMaker.makeRequest(url, options, expectedResponses);
    }
}
exports.default = FormsServiceClient;
//# sourceMappingURL=FormsServiceClient.js.map